import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import moment from "moment";
import { FlatpickrOptions } from "ng2-flatpickr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AbsencesService } from "../../../../../auth/service/absences.service";
import Italian from "flatpickr/dist/l10n/it";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { TutorialService } from "app/auth/service/tutorial.service";
import { IAbsence, IAbsenceForm, IAbsenceType } from "app/auth/models/absences";

@Component({
  selector: "app-popup-holidays",
  templateUrl: "./popup-holidays.component.html",
  styleUrls: ["./popup-holidays.component.scss"],
})
export class PopupHolidaysComponent implements OnInit {
  @ViewChild("content") content;
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  public formGroup: FormGroup;
  public todayDate = moment();
  public basicDateOptions: FlatpickrOptions;
  public absenceTypesList: IAbsenceType[] = [];
  public requireFile: boolean = false;
  public requireNote: boolean = false;
  private holidaysFile: string = "";
  public notAvailableDate: string[] = [];
  public myAbsences: IAbsence[] = [];
  public fileName: string = null;
  public showErrors: boolean = false;

  constructor(
    public _modalService: NgbModal,
    private _formBuilder: FormBuilder,
    public _absencesService: AbsencesService,
    public _utilService: UtilsService,
    public _tutorialService: TutorialService,
  ) {}

  async ngOnInit() {
    this.formGroup = this._formBuilder.group({
      type: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      note: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      from: new FormControl("", [Validators.required, Validators.pattern("^\\d{4}\\-(0?[1-9]|1[012])\\-(0?[1-9]|[12][0-9]|3[01])$")]),
      to: new FormControl("", [Validators.required, Validators.pattern("^\\d{4}\\-(0?[1-9]|1[012])\\-(0?[1-9]|[12][0-9]|3[01])$")]),
    });
    await this.loadHolidaysTypes();
    await this.notAvailablesDate();
    this.basicDateOptions = {
      altFormat: "d/m/Y",
      defaultDate: "today",
      locale: Italian.it,
      altInput: true,
      utc: true,
      minDate: "today",
      disable: this.notAvailableDate,
      disableMobile: true,
    };
    this.openModal();
  }

  openModal() {
    this._modalService.open(this.content, {
      centered: true,
      size: "sm",
      backdrop: false,
      keyboard: false,
    });
  }

  async loadHolidaysTypes() {
    this.absenceTypesList = await this._absencesService.getTypeList();
    this.absenceTypesList = this.absenceTypesList.filter((item) => item.type === "ferie");
  }

  async notAvailablesDate() {
    await this._absencesService.getMineAbsences();
    this.myAbsences = this._absencesService.myAbsences;
    this.myAbsences = this.myAbsences.filter((item) => item.status == 1);
    this.myAbsences.map((item: IAbsence) => {
      const absenceDate: moment.Moment = moment(item.from.split("T")[0]).utc();
      if (!absenceDate || !absenceDate.isValid) return;

      const from: moment.Moment = moment(item.from).utc();
      const to: moment.Moment = moment(item.to).utc();

      if (item.type.category !== "permesso") {
        // Se è un permesso quindi singolo giorno non facciamo nulla
        const difference: number = to.diff(from, "days");

        for (let i = 0; i <= difference; i++) {
          absenceDate.add(1, "days");
          this.notAvailableDate.push(absenceDate.format("YYYY-MM-DD"));
        }
      }
    });
  }

  modalClose() {
    this._modalService.dismissAll();
    this.formGroup.reset();
    this._utilService.toggleAbsencePopup("holidays");
  }

  checkAdditionalInput() {
    let selectedAbsence: IAbsenceType[] = null;
    if (this.formGroup.value.type) {
      let selectedTypeAbsences: number = this.formGroup.value.type;
      selectedAbsence = this.absenceTypesList.filter((item) => item.id === selectedTypeAbsences && (item.require_file === 1 || item.require_note === 1));
      if (selectedAbsence.length > 0) {
        this.requireFile = selectedAbsence[0].require_file === 1;
        this.requireNote = selectedAbsence[0].require_note === 1;
      } else {
        this.requireFile = false;
        this.requireNote = false;
      }
    }
  }

  async handlerChangeFileInput(event: { target: { files: { name: string }[] } }) {
    this.fileName = event.target.files[0].name;
    await this._utilService.convertFileToBase64(event, async (e: { target: { result: string } }) => {
      return (this.holidaysFile = e.target.result);
    });
  }

  async sendAbsenceRequest() {
    if (this.formGroup.value.type == "") {
      await this._utilService.showSWALError({ text: "INSERT_TYPE_HOLIDAY" });
      return false;
    }

    const from: moment.Moment = moment(this.formGroup.value.from[0]);
    const to: moment.Moment = moment(this.formGroup.value.to[0]);
    if (this.requireNote && this.formGroup.value.note.length < 1) {
      await this._utilService.showSWALError({ text: "ERROR_NOTE_REQUIRE" });
      return false;
    }

    if (this.requireFile && this.holidaysFile.length < 1) {
      await this._utilService.showSWALError({ text: "ERROR_FILE_REQUIRE" });
      return false;
    }

    if (to < from) {
      await this._utilService.showSWALError({ text: "ERROR_DATE_REQUESTED" });
      return false;
    }

    const data: IAbsenceForm = {
      type: this.formGroup.value.type,
      from: from.format("YYYY-MM-DD [00:00:00]"),
      to: to.format("YYYY-MM-DD [00:00:00]"),
      note: this.formGroup.value.note,
    };

    this._utilService.showLoading();
    await this._absencesService
      .sendAbsence(data)
      .then(async (response: { file_name: string; id: number }) => {
        if (this.requireFile) {
          this._utilService.hideLoading();
          const uploadFile = await this._utilService.upload_media("documents", response.file_name, this.holidaysFile);
          if (uploadFile) {
            await this._absencesService.updateAbsence(response.id, { has_file: 1 });
          }
        }
        this._utilService.hideLoading();
        this.callbackFn.emit();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_SEND_HOLIDAY" });
        this.modalClose();
      })
      .catch((response) => {
        if (response === "absence already exist") {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ERROR_ABSCENCE_ALREADY_REQUESTED" });
        } else {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ERROR_SEND_HOLIDAY" });
        }
      });
  }

  showVideo() {
    this._tutorialService.video_to_play = "Richiesta Ferie";
    this._tutorialService.force_open_modal = true;
  }

  fieldHasErrors(field_name: string): boolean {
    return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
  }
}

// [disabled]="!formGroup.value.type && !formGroup.value.from && !formGroup.value.to"
